<div class="auth-wrapper">
  <div class="auth-card">
    <div class="auth-logo">
      <img
        src="assets/img/entrustedLogoBlack.png"
        alt="branding logo"
        />
    </div>

    <h1 class="auth-title">Reset Password</h1>
    <p class="auth-subtitle">Enter your new password</p>

    @if (successMessage) {
      <div class="alert alert-success">
        {{ successMessage }}
      </div>
    }
    @if (errorMessage) {
      <div class="alert alert-danger">
        {{ errorMessage }}
      </div>
    }

    <form
      class="form-horizontal form-simple"
      #resetPasswordForm="ngForm"
      (ngSubmit)="onSubmit()"
      novalidate
      >
      <div class="form-group">
        <label for="email" class="d-none">Email</label>
        <input
          type="email"
          name="email"
          [(ngModel)]="model.email"
          class="form-control"
          id="email"
          placeholder="Enter Email"
          required
          autocomplete="email"
          />
      </div>
      <div class="form-group">
        <label for="password" class="d-none">New password</label>
        <input
          type="password"
          name="password"
          [(ngModel)]="model.password"
          class="form-control"
          id="password"
          placeholder="Enter new password"
          required
          autocomplete="new-password"
          />
      </div>
      <div class="form-group">
        <label for="confirmPassword" class="d-none">Confirm new password</label>
        <input
          type="password"
          name="confirmPassword"
          [(ngModel)]="model.confirmPassword"
          class="form-control"
          id="confirmPassword"
          placeholder="Confirm new password"
          required
          autocomplete="new-password"
          />
      </div>

      <button
        type="submit"
        class="btn btn-success"
        [disabled]="resetPasswordForm.invalid || clicked === true"
        >
        {{ clicked ? "Submitting..." : "Submit" }}
      </button>
    </form>

    <div class="auth-footer">
      <a routerLink="/login">Back to sign in</a>
    </div>
  </div>
</div>
